//
// TooltipDrillController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/models/data/hierarchy/Hierarchy";

var TooltipDrillController = createModule("BIRD::TooltipDrillController", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getLabel: [7],
        getHierarchyName: [7],
        getOneLevelUpLabel: [7],
        getConstantLevelValues: [[7]],
        _drillDown_o: [0,1],
        _collapse_o: [0,1],
        getCurrentLevelItemNames: [[7]],
        _drillUp_n: [0,4],
        _drillDown_v: [0],
        _canDrillDown_o: [2,1],
        canExpandAll: [2],
        _drillUp_v: [0],
        getConstantLevelLabels: [[7]],
        _canExpand_v: [2],
        _expand_v: [0],
        _canExpand_o: [2,1],
        drillDownFromLevel: [0,4,1],
        canDrillUp: [2],
        getPickedValue: [7],
        canCollapseAll: [2],
        _canDrillDown_v: [2],
        _canCollapse_v: [2],
        expandAll: [0],
        collapseAll: [0],
        setPickResults: [0,[1]],
        _collapse_v: [0],
        _canCollapse_o: [2,1],
        getCurrentLevelLabel: [7],
        _expand_o: [0,1],
        getOneLevelDownLabel: [7],
        getHierarchy: [1],
    },
    ,
    ["collapse","drillDown","canCollapse","canDrillDown","canExpand","expand","drillUp"],
]);
export default TooltipDrillController;
